<template>
    <v-container fluid class="py-6 px-6 integrations-page">
        <v-row>
            <v-col cols="12">
                <div class="mb-4">
                    <div class="header-eyebrow mb-1">Integrations</div>
                    <h2 class="text-h5 mb-1">Connected services</h2>
                    <p class="mb-0 integrations-help-text">
                        Connections you set up here are shared by everyone in your company and can be used across the Quaro suites.
                    </p>
                </div>
            </v-col>
        </v-row>

        <!-- Google Search Console -->
        <v-row>
            <v-col cols="12">
                <v-card outlined class="pa-4 integrations-card">
                    <div class="d-flex align-center mb-1">
                        <v-icon color="primary" class="mr-2">mdi-google</v-icon>
                        <span class="font-weight-bold text-h6">Google Search Console</span>
                    </div>
                    <p class="mb-4 integrations-help-text">
                        Connect the Google account that has access to your Search Console properties. Quaro reads the search queries, clicks, impressions and positions of your sites and
                        never changes anything in your Google account. The connection is shared across the Quaro suites, starting with the SEO AI.
                    </p>
                    <SearchConsoleConnection show-properties intro="Sign in with the Google account that has access to your properties. You can disconnect at any time." @notify="notify"></SearchConsoleConnection>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    // Einstellungen > Integrations: zentrale Stelle für Verbindungen zu Fremddiensten, die dem ganzen
    // Kunden gehören. Aktuell die Google Search Console (Tokens pro Kunde in der Monitoring-API).
    import SearchConsoleConnection from "./SearchConsoleConnection"

    export default {
        name: "IntegrationsSettings",
        components: {
            SearchConsoleConnection
        },
        methods: {
            // Settings.vue erwartet createInfo(message, color, icon)
            notify(message, icon, color) {
                this.$emit("info", message, color, icon)
            }
        }
    }
</script>

<style scoped>
    .integrations-help-text {
        font-size: 14px;
        line-height: 1.5;
        opacity: 0.85;
    }
    .header-eyebrow {
        font-size: 12px;
        letter-spacing: 0.08em;
        text-transform: uppercase;
        opacity: 0.6;
    }
    .integrations-card {
        border-radius: 12px;
    }
</style>
